(function () {
  'use strict';

  if (!document.body.classList.contains('template-product-pdp-redesign')) return;

  if (window.JCIPDPLooxEnhancer) {
    window.JCIPDPLooxEnhancer.enhance();
    return;
  }

  var scheduled = false;
  var observer = null;
  var reviewCountPattern = /(\(\s*[\d,.]+\s+reviews?\s*\))/i;

  function wrapReviewCount(label) {
    if (label.querySelector('.pdp-loox-review-count')) return true;

    var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    var textNode;

    while ((textNode = walker.nextNode())) {
      var match = textNode.nodeValue.match(reviewCountPattern);
      if (!match) continue;

      var before = textNode.nodeValue.slice(0, match.index);
      var after = textNode.nodeValue.slice(match.index + match[0].length);
      var fragment = document.createDocumentFragment();
      var count = document.createElement('span');

      if (before) fragment.appendChild(document.createTextNode(before));
      count.className = 'pdp-loox-review-count';
      count.textContent = match[0];
      fragment.appendChild(count);
      if (after) fragment.appendChild(document.createTextNode(after));

      textNode.parentNode.replaceChild(fragment, textNode);
      return true;
    }

    return false;
  }

  function makeWrapperKeyboardAccessible(rating) {
    var wrapper = rating.closest('a, button, [role="button"]');
    if (!wrapper) return;

    var isNativeButton = wrapper.tagName === 'BUTTON';
    var isLinkedAnchor = wrapper.tagName === 'A' && wrapper.hasAttribute('href');

    if (!isNativeButton && !isLinkedAnchor) {
      wrapper.setAttribute('role', 'button');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('data-pdp-loox-keyboard-trigger', '');
    }
  }

  function enhanceRating(rating) {
    var label = rating.querySelector('.loox-rating-label');
    if (!label || !wrapReviewCount(label)) return;

    if (!rating.querySelector('.pdp-loox-read-reviews')) {
      var readReviews = document.createElement('span');
      var content = rating.querySelector('.loox-rating-content') || rating;

      readReviews.className = 'pdp-loox-read-reviews';
      readReviews.setAttribute('aria-hidden', 'true');
      readReviews.textContent = 'Read Reviews';
      content.appendChild(readReviews);
    }

    makeWrapperKeyboardAccessible(rating);
    rating.setAttribute('data-pdp-loox-enhanced', '');
  }

  function enhance() {
    scheduled = false;
    document.querySelectorAll('.pdp-redesign .loox-rating').forEach(enhanceRating);
  }

  function scheduleEnhancement() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(enhance);
  }

  function handleKeyboardActivation(event) {
    var trigger = event.target.closest('[data-pdp-loox-keyboard-trigger]');
    if (!trigger || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    trigger.click();
  }

  function init() {
    enhance();
    document.addEventListener('keydown', handleKeyboardActivation);
    document.addEventListener('shopify:section:load', scheduleEnhancement);
    document.addEventListener('shopify:block:select', scheduleEnhancement);

    var main = document.getElementById('main') || document.querySelector('main');
    if (main) {
      observer = new MutationObserver(scheduleEnhancement);
      observer.observe(main, { childList: true, characterData: true, subtree: true });
    }
  }

  window.JCIPDPLooxEnhancer = {
    enhance: scheduleEnhancement
  };

  init();
})();
